import { Button } from "@swot/base-components";

export function SwotPermissionDenied(props: { readonly title?: string | undefined; readonly message?: string | undefined; readonly permission?: string | undefined; readonly actionCode?: string | undefined; readonly onBack?: (() => void) | undefined }) {
  return (
    <section className="swot-permission-denied" role="alert">
      <h2>{props.title ?? "Permission denied"}</h2>
      <p>{props.message ?? "You do not have permission to perform this action."}</p>
      {props.permission ? <p><strong>Permission:</strong> {props.permission}</p> : null}
      {props.actionCode ? <p><strong>Action:</strong> {props.actionCode}</p> : null}
      {props.onBack ? <Button label="Back" variant="secondary" onClick={props.onBack} /> : null}
    </section>
  );
}
